import BoardContentContext from '@/context/apps/board/BoardContentContext';
import Link from '@/routing/AppLink';
import { useRouter } from '@/routing/useAppRouter';
import { useTranslation } from 'next-i18next/pages';
import React, { useContext } from 'react';

import { buildNewsArticleSegment } from '@/utils/newsUrl';

/** TODO - 게시판 관련 컴포넌트는 따로 분리 필요해 보임 */
export default function BoardDetailPagination() {
  const { t } = useTranslation('common');

  const context = useContext(BoardContentContext);
  if (!context) {
    throw new Error('Cannot find BoardContentContext');
  }

  const prevInfo = context?.data?.prev_bc;
  const nextInfo = context?.data?.next_bc;

  const { asPath } = useRouter();
  const pathname = asPath.split('?')[0];
  const detailBasePath = pathname.replace(/\/[^/]+$/, '');
  const isNewsDetail = detailBasePath.endsWith('/about/news');
  const buildDetailUrl = (article: NonNullable<typeof prevInfo>) =>
    `${detailBasePath}/${
      isNewsDetail ? buildNewsArticleSegment(article) : article.idx
    }`;

  return (
    <div>
      <dl className="flex min-h-[72px] items-center gap-6 overflow-hidden border-b border-solid border-apps-coreProductDivider px-6 py-[14px] text-sm font-medium">
        <dt className="flex w-[50px] flex-shrink-0 text-center text-sm font-normal leading-[150%] text-apps-brandGray100">{t('다음글')}</dt>
        <dd className="w-full overflow-hidden text-apps-coreGrayBlack">
          {nextInfo?.idx ? (
            <Link
            className="block max-w-fit overflow-hidden text-ellipsis whitespace-nowrap py-2.5 text-base font-normal leading-[150%] text-apps-coreGrayBlack" href={buildDetailUrl(nextInfo)}>
              {nextInfo.title}
            </Link>
          ) : (
            <span className="block w-full overflow-hidden text-ellipsis whitespace-nowrap py-2.5 text-base font-normal leading-[150%] text-apps-brandGray100">{t('다음글이 없습니다.')}</span>
          )}
        </dd>
      </dl>
      <dl className="flex min-h-[72px] items-center gap-6 overflow-hidden border-b border-solid border-apps-coreProductDivider px-6 py-[14px] text-sm font-medium">
        <dt className="flex w-[50px] flex-shrink-0 text-center text-sm font-normal leading-[150%] text-apps-brandGray100">{t('이전글')}</dt>
        <dd className="w-full overflow-hidden text-apps-coreGrayBlack">
          {prevInfo?.idx ? (
            <Link
            className="block max-w-fit overflow-hidden text-ellipsis whitespace-nowrap py-2.5 text-base font-normal leading-[150%] text-apps-coreGrayBlack" href={buildDetailUrl(prevInfo)}>
              {prevInfo.title}
            </Link>
          ) : (
            <span className="block w-full overflow-hidden text-ellipsis whitespace-nowrap py-2.5 text-base font-normal leading-[150%] text-apps-brandGray100">{t('이전글이 없습니다.')}</span>
          )}
        </dd>
      </dl>
    </div>
  );
}

